// 1. Importamos tu nuevo motor matemático de Bancomer (Asegúrate de que la ruta sea correcta)
import { generarReferenciaBBVA } from './DigitoverBBVA.js';

/**
 * Genera la Línea de Captura Módulo 97 para ambos bancos (Banorte y Bancomer).
 * @param {string} plantel - Clave del plantel a 2 dígitos (ej. "01").
 * @param {array} conceptos - Arreglo con las claves de los conceptos (ej. ["15", "27"]). Máximo 5.
 * @param {string} matricula - Matrícula del alumno a 14 dígitos.
 * @param {number} monto - Cantidad a pagar (ej. 450.50).
 * @returns {object} Un objeto con los detalles de cobro para ambos bancos.
 */
const generarLineaCaptura = (plantel, conceptos, matricula, monto) => {
  
  // =========================================================
  // MOTOR 1: LÓGICA DE BANORTE (Intacta)
  // =========================================================
  
  // 0. PREPARAR LA REFERENCIA BASE (R) - 26 Posiciones
  const strPlantel = String(plantel).padStart(2, "0");
  const strConceptos = conceptos.join("").padEnd(10, "0").substring(0, 10); 
  const strMatricula = String(matricula).padStart(14, "0").substring(0, 14);
  const referenciaBase = `${strPlantel}${strConceptos}${strMatricula}`;

  // PASO 1: FECHA CONDENSADA (F) - 4 Posiciones
  const hoy = new Date();
  const anio = hoy.getFullYear();
  const mes = hoy.getMonth() + 1; 
  const ultimoDia = new Date(anio, mes, 0).getDate(); 
  
  const calculoAnio = (anio - 2013) * 372;
  const calculoMes = (mes - 1) * 31;
  const calculoDia = ultimoDia - 1;
  const fechaCondensadaNum = calculoAnio + calculoMes + calculoDia;
  const fechaCondensada = String(fechaCondensadaNum).padStart(4, "0");

  // PASO 2: IMPORTE CONDENSADO (I) - 1 Posición
  const montoStr = Number(monto).toFixed(2).replace(".", "");
  const factoresImporte = [7, 3, 1];
  let sumaImporte = 0;
  let iteradorImporte = 0;
  
  for (let i = montoStr.length - 1; i >= 0; i--) {
    const digito = parseInt(montoStr[i], 10);
    const factor = factoresImporte[iteradorImporte % 3];
    sumaImporte += (digito * factor);
    iteradorImporte++;
  }
  const importeCondensado = String(sumaImporte % 10);

  // CONSTANTE (C) - 1 Posición
  const constante = "2";
  
  // PASO 3: DÍGITOS VERIFICADORES M97 (D) - 2 Posiciones
  const cadenaParaVerificador = `${referenciaBase}${fechaCondensada}${importeCondensado}${constante}`;
  const factoresM97 = [11, 13, 17, 19, 23];
  let sumaM97 = 0;
  let iteradorM97 = 0;
  
  for (let i = cadenaParaVerificador.length - 1; i >= 0; i--) {
    const valorNum = parseInt(cadenaParaVerificador[i], 10);
    const factorM97 = factoresM97[iteradorM97 % 5];
    sumaM97 += (valorNum * factorM97);
    iteradorM97++;
  }
  const remanenteM97 = sumaM97 % 97;
  const digitosVerificadores = String(remanenteM97 + 1).padStart(2, "0");

  // RESULTADO FINAL BANORTE
  const lineaDeCapturaBanorte = `${cadenaParaVerificador}${digitosVerificadores}`;

  // Empaquetamos todo lo de Banorte
  const resultadoBanorte = {
    lineaDeCaptura: lineaDeCapturaBanorte,
    referenciaBase,
    fechaVencimientoObj: new Date(anio, mes - 1, ultimoDia),
    fechaVencimientoStr: `${String(ultimoDia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${anio}`,
    montoOriginal: Number(monto).toFixed(2)
  };

  // =========================================================
  // MOTOR 2: LÓGICA DE BANCOMER
  // =========================================================
  // Mandamos a llamar a nuestro motor con los mismos parámetros que ya tienes
  const resultadoBancomer = generarReferenciaBBVA(plantel, conceptos, matricula, monto);


  // =========================================================
  // RESPUESTA ORQUESTADA (Devolvemos ambos)
  // =========================================================
  return {
    banorte: resultadoBanorte,
    bancomer: resultadoBancomer
  };
};

export default generarLineaCaptura;